import { IApiResponse } from 'src/app/Shared/interface';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../app-insights.service';
import { IPaymentGatewayModel, IPaymentResponseModel } from 'src/app/Shared/interface2';
import { FingerPrintService } from '../fingerPrint/fingerprint.service';
import {AppService} from '../app.service';
import { EPaymentModes, EPaymentTransactionType } from 'src/app/Shared/enum';
import { PaymentService } from '../payment.service';


@Injectable({
    providedIn: 'root',
})

// tslint:disable-next-line: class-name
export class paymentGateWayService {
    private baseURL = this.appService.config.apiBaseUrl;
    // private paymentUrl= 'http://localhost:7044';
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                public fingerPrintService: FingerPrintService,
                private appService: AppService,
                private paymentService : PaymentService) { }

    processAutoPay(paymentGatewayModel: IPaymentGatewayModel): Observable<IPaymentResponseModel> {
        let options ={};
        if(this.fingerPrintService.isFingerPrintUsed) {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'secondary_userId': `${this.fingerPrintService.userId}` }) };
        } else {
            options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        }
        let url = `${this.baseURL}/Payments/EdgeExpressCCPayment`;
        return this.http.post<IPaymentResponseModel>(url, paymentGatewayModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    paymentReversal(paymentGatewayModel: IPaymentGatewayModel): Observable<IPaymentResponseModel> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/Payments/EdgeExpressCCReversal`;
        return this.http.post<IPaymentResponseModel>(url, paymentGatewayModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    batchInquiry(batchInquiryModel): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), };
        let url = `${this.baseURL}/Payments/EdgeExpressBatchInquiry`;
        return this.http.post<any>(url, batchInquiryModel, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
    //----------------------------Stripe------------------------------//
    mapStripeProcessedCC(processedStripeCC) {
        const stripeCC = {
            Amount: parseFloat(processedStripeCC.Amount),
            Autopay: false,
            PaymentModeId: processedStripeCC.PaymentModeId,
            AutoCcProcessingDay: 0,
            CreditCardNumber: processedStripeCC.CreditCardNumber,
            CreditCardType: processedStripeCC.CreditCardType,
            NameonCard: processedStripeCC.NameonCard,
            CreditCardExpiryMonth: processedStripeCC.CreditCardExpiryMonth,
            CreditCardExpiryYear: processedStripeCC.CreditCardExpiryYear,
            CreditCardBillingAddress: processedStripeCC.CreditCardBillingAddress,
            CreditCardBillingZip: processedStripeCC.CreditCardBillingZip,
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: processedStripeCC.AuthorizationCode,
            ResponseCode: processedStripeCC.ResponseCode,
            Reason: processedStripeCC.Reason,
            FacilityId: processedStripeCC.FacilityId,
            Key: processedStripeCC.Key,
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: processedStripeCC.cardType == 'debit' ? true : false,
            OfflinePayment: 0,
            UniqueTransId: processedStripeCC.UniqueTransId,
            PaymentTransactionTypeId: processedStripeCC.PaymentTransactionTypeId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            OrderId: processedStripeCC.OrderId,
            CCBatchNumber: '',
            TerminalDeviceId: null,
            TenantId: processedStripeCC.TenantId,
            GatewayDetails: processedStripeCC.GatewayDetails
        }
        return stripeCC;
    }

    getAddressElementOptions(isClear, customerInfo) {
        if (isClear) {
            return {
                mode: 'billing',
                fields: {
                    name: 'always',
                    address: 'always',
                    phone: 'always',
                    email: 'always'
                },
                defaultValues: {
                    name: '',
                    phone: '',
                    address: {
                        line1: '',
                        line2: '',
                        city: '',
                        state: '',
                        postal_code: '',
                        country: '',
                    }
                }
            };
        } else {
            return {
                mode: 'billing',
                fields: {
                    name: 'always',
                    address: 'always',
                    phone: 'always',
                    email: 'always'
                },
                defaultValues: {
                    name: customerInfo.FirstName + ' ' + customerInfo.MiddleName + ' ' + customerInfo.LastName,
                    phone: customerInfo.CellPhoneNumber,
                    address: {
                        line1: customerInfo.AddressOne,
                        line2: '',
                        city: customerInfo.City,
                        state: customerInfo.StateCode,
                        postal_code: customerInfo.PostalCode,
                        country: customerInfo.CountryCode,
                    },
                }
            };
        }
    }

    mountAddressElements(elements, enableAddressAutofill, mandatoryFieldsList) {
        const addressElementOptions = {
          mode: 'billing',
          autocomplete: {
            mode: enableAddressAutofill ? 'automatic' : 'disabled'
          },
          fields: {
            name: 'always',
            address: 'always',
            phone: 'always',
            email: 'always'
          },
          validation: {
            name: {
              required: this.getMandatoryFieldValue('tdFName', mandatoryFieldsList),
            },
            address: {
              line1: {
                required: this.getMandatoryFieldValue('tdAddress', mandatoryFieldsList),
              },
              line2: {
                required: this.getMandatoryFieldValue('tdAddress2', mandatoryFieldsList),
              },
              city: {
                required: this.getMandatoryFieldValue('tdCity', mandatoryFieldsList),
              },
              state: {
                required: this.getMandatoryFieldValue('tdState', mandatoryFieldsList),
              },
              postal_code: {
                required: this.getMandatoryFieldValue('tdZip', mandatoryFieldsList),
              },
              country: {
                required: this.getMandatoryFieldValue('tdCountry', mandatoryFieldsList),
              },
            },
            phone: {
              required: this.getMandatoryFieldValue('tdCellphone', mandatoryFieldsList),
            },
            email: {
              required: this.getMandatoryFieldValue('tdEmail', mandatoryFieldsList),
            },
          }
        };
        return addressElementOptions;
    }
    
    getMandatoryFieldValue(field, mandatoryFieldsList) {
        if (!mandatoryFieldsList.length) {
          return 'never';
        }
        let fieldObj = mandatoryFieldsList.find((ele) => ele.Name == field);
        if (fieldObj && fieldObj.Required) {
          return 'always'
        }
        return 'never';
    }

    mapStripeGatewayResponse(stripeRes, obj){
      const stripeCCModel = {
        Amount: parseFloat(stripeRes.Amount) / 100,
        Autopay: false,
        PaymentModeId: obj.PaymentMode,
        AutoCcProcessingDay: 0,
        CreditCardNumber: `XXXXXXXXXXX${stripeRes.CreditCardNumber}`,
        CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand),
        NameonCard: stripeRes?.CreditHolderName ?? "" ,
        CreditCardExpiryMonth: this.paymentService.getExpiryMonthValue(parseInt(stripeRes.ExpiryMonth, 10)),
        CreditCardExpiryYear: parseInt(stripeRes.ExpiryYear, 10),
        CreditCardBillingAddress : stripeRes?.BillingDetails?.Address ? ((stripeRes.BillingDetails.Address.Line1 ?? '') + ',' + (stripeRes.BillingDetails.Address.Line2 ?? '')).trim().slice(0, 50) : '',
        CreditCardBillingZip: stripeRes?.BillingDetails?.Address?.PostalCode ?? "",
        SwipeTransaction: false,
        SecurityCodeSent: false,
        AuthorizationCode: stripeRes.PaymentMethodId,
        Key: stripeRes.RefundIntentId,
        ResponseCode: stripeRes.ResponseCode,
        Reason: stripeRes.Reason && stripeRes.CardType != 'debit' ? stripeRes.Reason : stripeRes.Success ? 'Success' : 'Failed',
        PaymentAccountid: obj.PaymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
        CcInfoPurged: false,
        DebitCardPayment: stripeRes.CardType == 'debit',
        OfflinePayment: 0,
        PaymentTransactionTypeId: obj.PaymentTrnsId,
        TransactionDateTime: new Date(),
        TransactionTypeId: obj.TransactionTypeId,
        OrderId: obj.OrderId,
        EmvReceiptText: stripeRes.ReceiptUrl,
        TerminalDeviceId:  null,
        TenantId: obj.ProcessRefund?.TenantId ?? null,
        FacilityId: obj.ProcessRefund?.facId,
        PaymentMethodId: stripeRes.PaymentMethodId,
        GatewayDetails: obj?.RequestGatewayDetails ?? ""
      };
      return stripeCCModel;
    }
    
    //----------------------------Stripe------------------------------//

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
